import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import parking from "../../Assets/Projects/Car Parking.jpg";
import hotel from "../../Assets/Projects/Hotel.jpg";
import education from "../../Assets/Projects/Education.jpg";
import ford from "../../Assets/Projects/Ford.jpg";
import olympics from "../../Assets/Projects/olympics.jpg";
import airlines from "../../Assets/Projects/Airlines.jpg"
import tech from "../../Assets/Projects/Tech.jpg"
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here’s a glimpse into my recent work.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={airlines}
              isBlog={false}
              title="Comprehensive Data Analysis of Airline Operations"
              description={
                <>
                  The primary objective of this project was to conduct an in-depth analysis of airline operations to identify opportunities for enhancing occupancy rates on underperforming flights.
                  By optimizing occupancy levels, the airline can significantly improve profitability and operational efficiency.<br /><br/>
                  Skills Utilized: Data Manipulation, SQL, Data Visualization, Statistical Analysis
                </>
              }
              ghLink="https://github.com/Viraj0297/Comprehensive-Data-Analysis-of-Airline-Operations"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={education}
              isBlog={false}
              title="Education Recommendation System"
              description={
                <>
                  The Education Recommendation System is a data-driven application designed to empower students with personalized 
                  study recommendations tailored to their unique academic profiles. By leveraging advanced machine learning techniques, 
                  the system offers insights that help students make informed decisions about their educational paths, ultimately
                  enhancing their academic outcomes.<br /><br/>
                  Skills Utilized: Data Preprocessing, User Experience Design, Machine Learning, Recommendation System Development, Analytical Thinking
                </>
              }
              ghLink="https://github.com/Viraj0297/Education-Recommendation-System"
                           
            />
          </Col>

          <Col d={4} className="project-card">
            <ProjectCard
              imgPath={parking}
              isBlog={false}
              title="NCP Birmingham Parking Lot Data Analysis: Insights for Operational Optimization"
              description={
                <>
                 The NCP Birmingham parking lot plays a vital role in the bustling urban landscape of Birmingham,
                  serving as a crucial component of the city's transportation infrastructure. This analysis aimed to 
                  investigate the factors influencing parking occupancy, providing actionable insights for enhanced 
                  management and operational efficiency.<br /><br/>
                  Skills Utilized: Data Manipulation, Data Cleaning, Data Visualization, Statistical Modeling, Strategic Recommendations, Regression Analysis
                </>
              }
              ghLink="https://github.com/Viraj0297/NCP-Birmingham-Parking-Lot-Data-Analysis-Insights-for-Operational-Optimization"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={olympics}
              isBlog={false}
              title="Unveiling Olympic Trends: A Data-Driven Exploration of Global Athletic Achievement"
              description={
                <>
                  In the realm of data analysis, the ability to transform raw information into impactful insights is paramount.
                   In a recent project, a comprehensive examination of Olympic medal data was undertaken, employing Power BI to 
                  uncover underlying patterns and trends within this prestigious global sporting event.<br /><br/>
                  Skills Utilized: Data Preparation, Data Modelling, Visual Storytelling, Power BI
                </>
              }
              ghLink="https://github.com/Viraj0297/Unveiling-Olympic-Trends-A-Data-Driven-Exploration-of-Global-Athletic-Achievement"
                           
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hotel}
              isBlog={false}
              title="Hotel Booking Cancellation Analysis"
              description={
                <>
                  This project aims to conduct a comprehensive analysis of hotel booking data to identify patterns and 
                  key factors influencing booking cancellations. By uncovering these insights, the goal is to empower hotel 
                  management with data-driven strategies to enhance operational efficiency, optimize pricing, and improve customer retention.<br /><br/>
                  Skills Utilized: Exploratory Data Analysis (EDA), Data Visualization, Pattern Recognition, Statistical Analysis, Python, SQL
                </>
              }
              ghLink="https://github.com/Viraj0297/Hotel-Booking-Cancellation-Analysis-Prediction"
                           
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tech}
              isBlog={false}
              title="Case Study: Ethical Technology Use in India"
              description={
                <>
                  India's rapid technological advancements have positioned it as a global tech leader, yet this 
                  evolution brings pressing ethical questions about data privacy, security, and responsible usage. 
                  As the country embraces digital innovation, understanding the intricate ethical landscape involving 
                  stakeholders—government, technology companies, users, and unethical hackers—becomes essential.<br /><br/>
                  Skills Utilized: Research and Analysis, Stakeholder Analysis, Problem-Solving, Collaborative Strategy Development, SWOT analysis, Soft System Methodology 
                </>
              }
             
                           
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ford}
              isBlog={false}
              title="Analysing the UK Second-Hand Car Market (Ford Focus)"
              description={
                <>
                  In today’s fast-evolving automotive industry, understanding the intricacies of the second-hand car market is critical. 
                  I embarked on this project with one key objective: to unravel the factors that influence the pricing of the Ford Focus 
                  model in the UK market. Leveraging data from Autotrader over a five-year span (2019-2023), I explored how variables 
                  like mileage, fuel type, car segment, and registration year shaped pricing trends. This analysis helped Car4all refine 
                  their pricing strategies and position the Ford Focus more competitively.<br /><br/>
                  Skills Utilized: Data Collection and Management, Descriptive Analytics, Hypothesis Testing, Market Trend Analysis,Predictive Modeling, Python, SPSS, Excel
                </>
              }
             
             
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
